import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { NotificationService } from '../services/notification/notification.service';
import { SystemNotification } from '../models/system-notification.model';

@Component({
    selector: 'ccs-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  loginDisplay = true;
  notifications: SystemNotification[] = [];
  loadingNotifications = true;
  private readonly destroy$ = new Subject<void>();

  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  protected authenticated = this.authService.signedIn;
  protected username = this.authService.getUserName();

  ngOnInit(): void {
    this.loadSystemNotifications();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSystemNotifications(): void {
    this.notificationService.getSystemNotifications()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications;
          this.loadingNotifications = false;
        },
        error: (error) => {
          console.error('Failed to load system notifications:', error);
          this.loadingNotifications = false;
        }
      });
  }

  getAlertClass(type: string): string {
    const typeMap: { [key: string]: string } = {
      'info': 'alert-info',
      'warning': 'alert-warning',
      'error': 'alert-danger',
      'success': 'alert-success'
    };
    return typeMap[type] || 'alert-info';
  }

  getIconClass(type: string): string {
    const iconMap: { [key: string]: string } = {
      'info': 'bi-info-circle-fill',
      'warning': 'bi-exclamation-triangle-fill',
      'error': 'bi-x-circle-fill',
      'success': 'bi-check-circle-fill'
    };
    return iconMap[type] || 'bi-info-circle-fill';
  }

  isHighPriority(priority: 'low' | 'medium' | 'high' | 'critical'): boolean {
    return priority === 'high' || priority === 'critical';
  }

}
